import utils from "../services/utils";

let azure = require("azure-storage");
let c3 = require("c3");
let $ = require("jquery");
let dt = require("datatables.net-bs4");

let campaign = {
  render: async () => {
    let view = /*html*/ `
        <div id="container" class="container-fluid">
          <div class="row text-center">
            <div class="col"><h1>Campaign <span id="campaignId"><span></h1></div>
          </div>
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="dashboard-tab" data-toggle="tab" href="#dashboard" role="tab" aria-controls="dashboard" aria-selected="true">Dashboard</a>
            </li>
            <li class="nav-item">
            <a class="nav-link" id="data-tab" data-toggle="tab" href="#data" role="tab" aria-controls="data" aria-selected="false">Data</a>
            </li>
            <li class="nav-item">
            <a class="nav-link" id="rawdata-tab" data-toggle="tab" href="#rawdata" role="tab" aria-controls="rawdata" aria-selected="false">Raw Data</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
            <div id="chart"></div>
            </div>
            <div class="tab-pane" id="data" role="tabpanel" aria-labelledby="data-tab">
              <table id="data-table" class="table table-bordered table-hover table-sm" style="width: 100%">
                <tfoot>
                    <tr>
                        <td></td>
                        <th>Campaign ID</th>
                        <th>Received At</th>
                        <th>Played At</th>
                        <th>Lag</th>
                        <th>Format ID</th>
                        <th>Frame ID</th>
                        <th>Duration</th>
                        <th>Time Zone</th>
                        <th>Trigger</th>
                        <th>Poster ID</th>
                        <th>Media Owner</th>
                        <th>Poster Title</th>
                        <th>Fallback</th>
                    </tr>
                </tfoot>
              </table>
            </div>
            <div class="tab-pane" id="rawdata" role="tabpanel" aria-labelledby="rawdata-tab">
              <table id="rawdata-table" class="table table-bordered table-hover table-sm" style="width: 100%"></table>
            </div>
          </div>
      </div>
    `;
    return view;
  },
  after_render: async () => {
    Array.from(document.getElementsByClassName("loader")).forEach((x) => (x.style.display = "block"));
    document.getElementById("loadtime").textContent = "";
    let startTime = new Date();

    let url = utils.parseRequestUrl();
    let campaignId = url.id;
    document.getElementById("campaignId").textContent = campaignId;
    let to = +url.query["lastreceived"];
    let from = +url.query["lastreceived"] - 60 * 60 * 10000000; // subtract 1 hour - there are 10 million ticks in one second

    let tableStorageAccount = utils.getDropDownValue(document.getElementById("storage-account"));
    let sasToken = await utils.getSasToken(tableStorageAccount);
    if (!sasToken) {
      console.error(`No SAS token found for selected storage account, please configure`);
      return;
    }
    let tableService = azure.createTableServiceWithSas(tableStorageAccount, sasToken);
    let getPlayoutsQuery = new azure.TableQuery()
      .where("PartitionKey eq ?", campaignId)
      .and("RowKey gt ?", from.toString())
      .and("RowKey lt ?", to.toString());
    console.log("Table storage query:", getPlayoutsQuery);

    queryEntitiesSegmented(tableService, getPlayoutsQuery, null, [], startTime);
  },
};

const queryEntitiesSegmented = (tableService, query, token, entries, startTime) => {
  console.log("Querying table storage ...");
  let options = { payloadFormat: "application/json;odata=nometadata" };
  let selectedTenant = utils.getDropDownValue(document.getElementById("tenant"));
  tableService.queryEntities(
    `${selectedTenant}PlayoutReports`,
    query,
    token,
    options,
    function (error, result, response) {
      if (error) throw error;

      result.entries.forEach((x) => {
        x.PlayoutReportData._ = JSON.parse(x.PlayoutReportData._);
        if (!x.PlayoutReportData._.dt.endsWith("Z")) x.PlayoutReportData._.dt += "Z";
        x.PlayoutReportData._.dt = x.PlayoutReportData._.dt.replace(" ", "T");
      });

      entries.push(...result.entries);
      console.log(`Parsed ${entries.length} results`);
      console.log(`Earliest result: ${new Date(utils.dotNetTicksToJsTicks(entries[0].RowKey._)).toISOString()}`);
      console.log(
        `Latest result: ${new Date(utils.dotNetTicksToJsTicks(entries[entries.length - 1].RowKey._)).toISOString()}`
      );

      // let frameIds = entries.filter(x => x.PlayoutReportData._.fmi == '1369').map(x => x.PlayoutReportData._.fid).sort();
      // console.log(frameIds);
      // let uniqueFrameId = [...new Set(frameIds)];
      // console.log(uniqueFrameId);

      //36,000,000,000 = 1 minute

      if (result.continuationToken) {
        let differenceInDotNetTicksBetweenFirstAndLast = entries[entries.length - 1].RowKey._ - entries[0].RowKey._;
        let dotNetTicksInOneHour = 36000000000;
        let percentComplete = Math.round((differenceInDotNetTicksBetweenFirstAndLast / dotNetTicksInOneHour) * 100);
        document.getElementById("loader-percentage").innerHTML =
          (percentComplete < 10 ? "&nbsp" : "") + percentComplete + "%";
        queryEntitiesSegmented(tableService, query, result.continuationToken, entries, startTime);
      } else {
        document.getElementById("loader-percentage").innerHTML = "";
        console.log("Finished querying");
        let t1 = utils.timer("Bind Raw Data");
        bindRawData(entries);
        t1();
        let t2 = utils.timer("Bind Data");
        bindData(entries);
        t2();
        let t3 = utils.timer("Bind Dashboard");
        bindDashboard(entries);
        t3();
        let endTime = new Date();
        document.getElementById("loadtime").textContent = `${(endTime - startTime) / 1000}s`;
        Array.from(document.getElementsByClassName("loader")).forEach((x) => (x.style.display = "none"));
      }
    }
  );
};

const bindRawData = (entries) => {
  let t = $("#rawdata-table").DataTable({
    pageLength: 25,
    data: entries,
    columns: [
      { data: null },
      { data: "PartitionKey._", title: "Partition Key" },
      { data: "RowKey._", title: "Row Key" },
      { data: "Timestamp._", title: "Timestamp" },
      { data: "RemoteIpAddress._", title: "RemoteIpAddress" },
      {
        data: "PlayoutReportData._",
        title: "Playout Report Data",
        className: "wrap",
        render: (d, t, r) => {
          return JSON.stringify(d);
        },
      },
    ],
    // define first column as an index
    columnDefs: [
      {
        searchable: false,
        orderable: false,
        targets: 0,
      },
    ],
    // sort on column three
    order: [[2, "asc"]],
  });

  // create index for table on first column
  t.on("order.dt search.dt", function () {
    t.column(0, { search: "applied", order: "applied" })
      .nodes()
      .each(function (cell, i) {
        cell.innerHTML = i + 1;
      });
  }).draw();
};

const bindData = (entries) => {
  // add a text input to each footer cell for filtering by column
  $("#data-table tfoot th").each(function () {
    var title = $(this).text();
    var className = ["Played At", "Received At"].includes(title) ? "wide-cell" : "regular-cell";
    $(this).html(`<input type="text" class="${className}" placeholder="Search ${title}" />`);
  });
  let t = $("#data-table").DataTable({
    pageLength: 25,
    data: entries,
    columns: [
      { data: null },
      { data: "PlayoutReportData._.cid", title: "Campaign ID" },
      {
        data: "RowKey._",
        title: "Received At",
        render: (d, t, r) => {
          if (t === "display" || t === "filter") {
            return new Date(utils.dotNetTicksToJsTicks(d)).toISOString();
          }
          return d;
        },
      },
      {
        data: "PlayoutReportData._.dt",
        title: "Played At",
        render: (d, t, r) => {
          if (t === "display" || t === "filter") {
            return new Date(d).toISOString();
          }
          return d;
        },
      },
      { data: (r) => getLagInSeconds(r.RowKey._, r.PlayoutReportData._.dt), title: "Lag" },
      { data: (r) => r.PlayoutReportData._.fmi || "", title: "Format ID" },
      { data: (r) => r.PlayoutReportData._.fid || "", title: "Frame ID" },
      { data: (r) => r.PlayoutReportData._.dur || "", title: "Duration" },
      { data: "PlayoutReportData._.tz", title: "Time Zone" },
      { data: (r) => r.PlayoutReportData._.trg || "", title: "Trigger" },
      { data: "PlayoutReportData._.pid", title: "Poster ID" },
      { data: (r) => r.PlayoutReportData._.mo || "", title: "Media Owner" },
      {
        data: (r) => {
          return r.PlayoutReportData._.crt
            ? r.PlayoutReportData._.crt
            : r.PlayoutReportData._.ptt
            ? r.PlayoutReportData._.ptt
            : "";
        },
        title: "Poster Title",
      },
      { data: "PlayoutReportData._.fb", title: "Fallback" },
    ],
    // define first column as an index
    columnDefs: [
      {
        searchable: false,
        orderable: false,
        targets: 0,
      },
    ],
    order: [[3, "asc"]],
    initComplete: function () {
      this.api()
        .columns()
        .every(function () {
          var that = this;

          $("input", this.footer()).on("keyup change clear", function () {
            if (that.search() !== this.value) {
              that.search(this.value).draw();
            }
          });
        });
    },
  });

  // create index for table on first column
  t.on("order.dt search.dt", function () {
    t.column(0, { search: "applied", order: "applied" })
      .nodes()
      .each(function (cell, i) {
        cell.innerHTML = i + 1;
      });
  }).draw();
};

const getLagInSeconds = (receivedAt, playedAt) => {
  let receivedAtInTicks = utils.dotNetTicksToJsTicks(receivedAt);
  let playedAtInTicks = new Date(playedAt).getTime();
  let lagInSeconds = Math.round(receivedAtInTicks - playedAtInTicks);
  switch (true) {
    case lagInSeconds < 1000:
      return lagInSeconds + "ms";
    case lagInSeconds < 1000 * 60:
      return Math.round(lagInSeconds / 1000) + "s";
    case lagInSeconds < 1000 * 60 * 60:
      return Math.round(lagInSeconds / (1000 * 60)) + "m";
    case lagInSeconds < 1000 * 60 * 60 * 24:
      return Math.round(lagInSeconds / (1000 * 60 * 60)) + "h";
    default:
      return Math.round(lagInSeconds / (1000 * 60 * 60 * 24)) + "d";
  }
};

const getPosterTitle = (entry) => {
  if (entry.PlayoutReportData._.fb === "true") return "fallback";
  if (entry.PlayoutReportData._.crt || entry.PlayoutReportData._.ptt)
    return entry.PlayoutReportData._.crt || entry.PlayoutReportData._.ptt;
  return entry.PlayoutReportData._.pid;
};

const bindDashboard = (entries) => {
  let timer = utils.timer("Extract data for creatives breakdown");

  let unordered = {}; // extract object with day-hour-minute keys with posters and play counts
  let data = {}; // the eventual chart data
  entries.forEach((x) => {
    let poster = getPosterTitle(x);
    if (!(poster in data)) {
      data[poster] = [];
    }
    //let dayHourMinute = new Date(x.PlayoutReportData._.dt).toISOString().slice(0, 16);
    let dayHourMinute = x.PlayoutReportData._.dt.slice(0, 16);
    unordered[dayHourMinute] = unordered[dayHourMinute] || {};
    unordered[dayHourMinute][poster] = unordered[dayHourMinute][poster] || 0;
    unordered[dayHourMinute][poster]++;
  });

  const ordered = {};
  Object.keys(unordered)
    .sort()
    .forEach(function (key) {
      ordered[key] = unordered[key];
    });

  const playedAtTimes = Object.keys(ordered);
  // TODO swap to timestamps for keys
  const earliest = new Date(playedAtTimes[0] + "Z").getTime();
  const latest = new Date(playedAtTimes[playedAtTimes.length - 1] + "Z").getTime();

  let posters = Object.keys(data);
  data.x = [];
  // iterate every minute from earliest to latest
  for (let t = earliest; t <= latest; t += 60000) {
    let day = new Date(t).toISOString().slice(0, 16);
    data.x.push(new Date(day));
    if (ordered[day]) {
      posters.forEach((p) => {
        let dataForDayForPoster = ordered[day][p] || 0;
        data[p].push(dataForDayForPoster);
      });
    } else {
      posters.forEach((p) => {
        data[p].push(0);
      });
    }
  }

  let groups = [];
  groups.push(posters);
  c3.generate({
    bindto: "#chart",
    size: {
      height: 550,
    },
    data: {
      x: "x",
      json: data,
      groups: groups,
      type: "bar",
    },
    axis: {
      x: {
        type: "timeseries",
      },
    },
  });
};

export default campaign;
